import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import 'handsontable/dist/handsontable.full.css'
import moment from 'moment'
import globalVariable from './utils/global_variable.js'
import BaiduMap from 'vue-baidu-map'
import VueResource from 'vue-resource'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
Vue.use(VueResource)

Vue.use(BaiduMap, {
  ak: 'MYmAqUe1VDAikSBA9a8XkP6R'
})

Vue.use(ElementUI)
Vue.config.productionTip = false;
import echarts from 'echarts'
import Jquery from 'jquery'
import './utils/request.js'
Vue.prototype.$echarts = echarts
Vue.prototype.$jquery = Jquery
Vue.prototype.$moment = moment
Vue.prototype.$GLOBAl = globalVariable
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
